import { Button, Tooltip } from "@sede-enterprise/shell-ds-react-framework";
import { InfoCircle } from "@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components";

const renderInfoData = (label, value, tooltip = null) => (
    <div className="info-data">
        <div className="info-label">
            <p className="data-label">{label}</p>
            {tooltip && (
                <Tooltip
                    className="tooltip"
                    placement="bottom"
                    overlay={<div className="tooltip-content">{tooltip}</div>}
                    trigger={<Button size="xsmall" variant="transparent" iconOnly icon={<InfoCircle />} />}
                />
            )}
        </div>
        <p className="data-value">{value}</p>
    </div>
);


export default renderInfoData;
